import React from "react"
import styled from "styled-components"

import { colors, fontWeight, fontSize } from "buoy-theme"
import { HeadingTwo } from "buoy-core"

const HeaderText = styled(HeadingTwo).attrs({
  margin: "0 0 12px"
})`
  font-weight: ${fontWeight.regular};
  ${fontSize("h3")};
  text-align: left;
  max-width: calc(100% - 32px);
  ::first-letter {
    text-transform: uppercase;
  }
`

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  border-bottom: solid 1px ${colors.neutralLight};
`

const Header = ({ text, id }) => (
  <Container id={id}>
    <HeaderText>{text}</HeaderText>
  </Container>
)

export { Header as default }



// WEBPACK FOOTER //
// ./assets/filters/components/Header.js